import { useEffect, useState } from 'react';
import axios from 'axios';
import { Period } from '../models/GoalsInterfaces';

export const useGetPeriods = () => {
  const [activePeriods, setActivePeriods] = useState<Period[]>([]);
  const [loadingActivePeriods, setLoadingActivePeriods] = useState(false);

  const removeFutureAndLatestInactive = (array: Period[]) => {
    const currentDate = new Date();
    const currentYear = currentDate.getFullYear();
    const currentMonth = currentDate.getMonth();

    let currentQuarter;
    if (currentMonth < 3) currentQuarter = 1;
    else if (currentMonth < 6) currentQuarter = 2;
    else if (currentMonth < 9) currentQuarter = 3;
    else currentQuarter = 4;

    // Remove future periods
    const nonFutureArray = array.filter((period) => {
      const [periodYear, periodQuarter] = period.new_name
        .split(' Q')
        .map(Number);
      return (
        periodYear < currentYear ||
        (periodYear === currentYear && periodQuarter <= currentQuarter)
      );
    });

    // Sort by descending order (latest first)
    const sortedArray = nonFutureArray.sort((a, b) => {
      const [yearA, quarterA] = a.new_name.split(' Q').map(Number);
      const [yearB, quarterB] = b.new_name.split(' Q').map(Number);
      return yearB - yearA || quarterB - quarterA;
    });

    // Remove latest inactive entries
    while (sortedArray.length > 0) {
      const latest = sortedArray[0];
      if (latest.statuscode === 1) {
        break;
      }
      sortedArray.shift();
    }

    return sortedArray;
  };

  const getAllActivePeriods = async () => {
    setLoadingActivePeriods(true);
    try {
      const response = await axios.get('/api/periods');
      const cleanedArray = removeFutureAndLatestInactive(response.data);
      setActivePeriods(cleanedArray);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingActivePeriods(false);
    }
  };

  useEffect(() => {
    getAllActivePeriods();
  }, []);

  return { activePeriods, loadingActivePeriods };
};
